<template>
  <p class="preparation">資料籌備中</p>
</template>

<script>
export default {
  name: 'PreparationMessage',
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
@keyframes opacityChange {
  0% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.preparation {
  border-top: 1px dashed;
  border-bottom: 1px dashed;
  padding: 20px 0;
  width: 100%;
  max-width: 400px;
  margin: 10px auto 0 !important;
  font-size: 1.3rem;
  animation: opacityChange 2s ease-out;
}
</style>
